/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var arcgisSource = _interopDefault(require('./arcgis-source'));
var featuresContainer = _interopDefault(require('./features-container'));
var geometry = _interopDefault(require('./geometry'));
var geometryContainer = _interopDefault(require('./geometry-container'));
var identMap = _interopDefault(require('./ident-map'));
var imageSource = _interopDefault(require('./image-source'));
var imageStyle = _interopDefault(require('./image-style'));
var interaction = _interopDefault(require('./interaction'));
var interactionsContainer = _interopDefault(require('./interactions-container'));
var layer = _interopDefault(require('./layer'));
var layersContainer = _interopDefault(require('./layers-container'));
var olCmp = _interopDefault(require('./ol-cmp'));
var olVirtCmp = _interopDefault(require('./ol-virt-cmp'));
var overlaysContainer = _interopDefault(require('./overlays-container'));
var projTransforms = _interopDefault(require('./proj-transforms'));
var rxSubs = _interopDefault(require('./rx-subs'));
var services = _interopDefault(require('./services'));
var source = _interopDefault(require('./source'));
var sourceContainer = _interopDefault(require('./source-container'));
var stubVnode = _interopDefault(require('./stub-vnode'));
var style = _interopDefault(require('./style'));
var stylesContainer = _interopDefault(require('./styles-container'));
var tileSource = _interopDefault(require('./tile-source'));
var useMapCmp = _interopDefault(require('./use-map-cmp'));
var vectorLayer = _interopDefault(require('./vector-layer'));
var vectorSource = _interopDefault(require('./vector-source'));
var withFillStrokeStyle = _interopDefault(require('./with-fill-stroke-style'));
var withUrl = _interopDefault(require('./with-url'));
var wmsSource = _interopDefault(require('./wms-source'));
var xyzSource = _interopDefault(require('./xyz-source'));

/**
 * @module mixin
 */

exports.arcgisSource = arcgisSource;
exports.featuresContainer = featuresContainer;
exports.geometry = geometry;
exports.geometryContainer = geometryContainer;
exports.identMap = identMap;
exports.imageSource = imageSource;
exports.imageStyle = imageStyle;
exports.interaction = interaction;
exports.interactionsContainer = interactionsContainer;
exports.layer = layer;
exports.layersContainer = layersContainer;
exports.olCmp = olCmp;
exports.olVirtCmp = olVirtCmp;
exports.overlaysContainer = overlaysContainer;
exports.projTransforms = projTransforms;
exports.rxSubs = rxSubs;
exports.services = services;
exports.source = source;
exports.sourceContainer = sourceContainer;
exports.stubVNode = stubVnode;
exports.style = style;
exports.stylesContainer = stylesContainer;
exports.tileSource = tileSource;
exports.useMapCmp = useMapCmp;
exports.vectorLayer = vectorLayer;
exports.vectorSource = vectorSource;
exports.withFillStrokeStyle = withFillStrokeStyle;
exports.withUrl = withUrl;
exports.wmsSource = wmsSource;
exports.xyzSource = xyzSource;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/index.js
// module id = 124
// module chunks = 1